<template>
  <v-layout row wrap v-if="lastMomentSecurity">
    <v-flex xs12 sm12>
      <img
        class="report_channel"
        height="250px"
        :src="lastMomentSecurity.main_image"
        alt="Imagen del Momento Security"
      />
    </v-flex>
    <v-flex xs12 sm12>
      <div class="text-center">
        <h3 class="cm-title text-blue-v2" style="margin-bottom: .5rem">Nuestros Momentos</h3>
        <h3 class="cm-subtitle text-blue-v2">{{ lastMomentSecurity.title }}</h3>
        <p class="py-3 text-18-security">
          {{ lastMomentSecurity.extract }}
        </p>
        <v-btn class="cm-btn-bg-white pa-4" @click="goToMoment(lastMomentSecurity.slug)">
          Ir a la noticia
        </v-btn>
        <a class="cm-btn-secondary" @click="goToMoments">Ver más Momentos</a>
      </div>
    </v-flex>
  </v-layout>
  <div v-else>
    <p>Cargando...</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("posts", ["lastMomentSecurity"]),
  },
  methods: {
    goToMoment(slug) {
      this.$router.push(`/noticias/${slug}`);
    },
    goToMoments() {
      this.$router.push('/momentos');
    },
  },
  created() {
    const viewAs = localStorage.getItem("view_as"); 
    this.$store.dispatch('posts/fetchLastMomentSecurity', viewAs);
  },
};
</script>

<style scoped>
img.report_channel {
  width: 100%;
  object-fit: cover;
}
.text-center {
  text-align: center;
  padding: 5%;
}
</style>
